import React, { useContext } from "react";
import io from "socket.io-client";

export const socket = io.connect(process.env.REACT_APP_WEB_SERVICE);
export const SocketContext = React.createContext(socket);


export default socket;
